import PropTypes from "prop-types";

import InputUtils from "../../lib/inputUtils";

import "./input.scss";

const Input = props => {
  return new InputUtils().renderInputComponent(props);
};

Input.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  isInvalid: PropTypes.bool,
  disableInputFeedback: PropTypes.bool,
  innerRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
    PropTypes.string
  ]),
  options: PropTypes.array,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  inline: PropTypes.bool,
  validationProps: PropTypes.any
};

Input.defaultProps = {
  type: "text",
  disableInputFeedback: false
};

Input.displayName = "OrionInput";

export default Input;
